import { QuickLoginModalHOC } from '@/components/modal/LoginModal2HOC';
import useToast from '@/hooks/useToast';
import { postBookmarkPost } from 'apis/tms/post.api';
import { PostContext } from 'context/PostContext';
import Button from 'design-system/components/Button/Button';
import Tooltips from 'design-system/components/Tooltips/Tooltips';
import { useContext } from 'react';
import { useMutation } from 'react-query';

const PostBookmarkButton = () => {
  const toast = useToast();
  const { postId } = useContext(PostContext);

  const { mutate } = useMutation({
    mutationFn: postBookmarkPost,
  });

  const onClick = () => {
    toast('Tính năng sắp được ra mắt', 'success');
    mutate(postId);
  };

  return (
    <QuickLoginModalHOC
      classname="cursor-pointer"
      handleClickWhenDisabledQuickLogin={onClick}
      loginSuccessCb={onClick}
    >
      <Tooltips title={'Lưu bài viết'}>
        <Button
          id="save_post_btn"
          size="medium"
          mode="icon-only"
          emphasis="medium"
          icon={{
            name: 'save',
          }}
        />
      </Tooltips>
    </QuickLoginModalHOC>
  );
};

export default PostBookmarkButton;
